module.exports = __webpack_public_path__ + "img/home.48c9cd80.svg";